import React from 'react'
import About from './About/About'
import ComSkills from './Skills/comskill'
import Skills from './Skills/skills'



const MiddleSection = () => {
  return (
    <div>
      <About/>
      <Skills/>
      <ComSkills/>
    </div>
  )
}

export default MiddleSection
